module.exports = __webpack_public_path__ + "img/maps.3dfd0d96.png";